import axios from 'axios';

const getBaseURL = () => {
  // 🚀 1. PRODUCTION: Always use a relative path. 
  // This completely eliminates CORS issues whether the user types 'www' or not.
  if ((import.meta as any).env.PROD) {
    return '/api';
  }

  // 🛠️ 2. LOCAL DEVELOPMENT: Use the .env variable (e.g., http://localhost:3000)
  const envUrl = (import.meta as any).env.VITE_API_URL;
  if (envUrl) {
    const cleanUrl = envUrl.endsWith('/') ? envUrl.slice(0, -1) : envUrl;
    return `${cleanUrl}/api`;
  }

  // 3. FALLBACK
  return '/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'ngrok-skip-browser-warning': 'true' // 🛡️ Prevents HTML injection blocks during local network testing
  },
  timeout: 10000, 
});

/**
 * 🛡️ REQUEST INTERCEPTOR
 * Automatically attaches the JWT to every request safely.
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * 🔄 RESPONSE INTERCEPTOR
 * Handles 401 (Expired/Unauthorized) and 403 (Deactivated) status codes.
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // 1. Handle Unauthorized (401) or Deactivated (403)
    if (response && (response.status === 401 || response.status === 403)) {
      const isDeactivated = response.status === 403;
      
      // Avoid redirect loops
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Redirect with a specific reason in the URL
        const reason = isDeactivated ? 'deactivated' : 'expired';
        window.location.href = `/login?reason=${reason}`;
      }
    }

    // 2. Handle Server Offline
    if (!response) {
      console.error("❌ Network Error: The backend server is unreachable.");
    }

    return Promise.reject(error);
  }
);

export default api;